import React from 'react';
import { Modal, ModalFooter, ModalBody, ModalHeader, Button, Input, InputGroup, FormGroup, Label, InputGroupText } from 'reactstrap';
import List from './List';
import { debounce } from 'debounce';

class Search extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            selectedCourses: [],
            addSections: this.props.showOptions,
            disableCourseAdd: true,
        }
    }

    handleSearchChange = (e) => this.throttledSearch(e.currentTarget.value);

    throttledSearch = debounce((searchTerm) => this.props.onSearch(searchTerm), 500);

    handleSelectionChanged = (selectedCourses) => this.setState({ selectedCourses, disableCourseAdd: selectedCourses.length > 0 ? false : true  });

    handleAdd = () => {
        this.props.onAdd(this.state.selectedCourses, this.state.addSections);
        this.setState({ disableCourseAdd: true });
    }

    handleAddSectionsChanged = () => this.setState({ addSections: !this.state.addSections });

    render() {

        return (
            <Modal
                scrollable={true}
                isOpen={this.props.isOpen}
                toggle={this.props.toggle}
                size='lg'
            >
                <ModalHeader toggle={this.props.toggle}>{this.props.title || 'Course Search'}</ModalHeader>
                <ModalBody>
                    <InputGroup className='pb-1'>
                        <InputGroupText>Search:</InputGroupText>
                        <Input type='text' onChange={this.handleSearchChange} />
                    </InputGroup>
                    <List
                        hideButtons={true}
                        courses={this.props.data}
                        onSelectionChanged={this.handleSelectionChanged}
                    />
                </ModalBody>
                <ModalFooter className='justify-content-between'>
                    <div>
                        {this.props.showOptions &&
                            <React.Fragment>
                                <FormGroup check>
                                    <Label check>
                                    <Input type="checkbox" checked={this.state.addSections} onChange={this.handleAddSectionsChanged} />Add Sessions of Selected Course(s)
                                    </Label>
                                </FormGroup>
                            </React.Fragment>
                        }
                    </div>
                    <div>
                        <Button color="primary" disabled={this.state.disableCourseAdd} onClick={this.handleAdd}>Add</Button>{' '}
                        <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default Search